import type { TFunction } from "i18next";

/** Codes whose copy is shared beyond the wall (the composer, a cast): their own key, not `wall_error_<code>`. */
const SHARED_KEYS: Record<string, [key: string, fallback: string]> = {
  PREVIEW_ONLY_LINK: ["link_preview_only", "This link only plays a preview here"],
};

/** A room-stc content code's copy: `wall_error_<code>`, or its shared key. */
export function contentErrorText(t: TFunction, code: string, fallback?: string): string {
  const shared = SHARED_KEYS[code];
  if (shared) return t(shared[0], shared[1]);
  return fallback === undefined ? t(`wall_error_${code}`) : t(`wall_error_${code}`, fallback);
}

/** The code's text wraps instead of truncating (Figma Composer item State=Preview only 4354:8004). */
export const wrapsErrorText = (code: string | undefined): boolean => code != null && code in SHARED_KEYS;
